export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/v2/landing-pages/_next/static/media/Swap.e7dd35af.svg","height":11,"width":14};